<template>
    <ol :class="[nested ? '' : 'gap-3']" class="flex list-none flex-col p-0">
        <li v-for="(step, index) in steps" :key="step.id" class="flex flex-col">
            <div class="flex items-start gap-3">
                <span v-if="nested" class="mt-2.5 size-1 shrink-0 rounded-full bg-black" />
                <span
                    v-else
                    class="mt-1 flex size-[18px] shrink-0 items-center justify-center rounded-full bg-[#E1ECFF] text-xs font-bold text-black"
                >
                    {{ index + 1 }}
                </span>
                <span class="pt-0.5">{{ getText(step) }}</span>
            </div>

            <guidance-steps-list v-if="step.steps?.length" :nested="true" :steps="step.steps" class="ml-9" />
        </li>
    </ol>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3';

defineProps({
    steps: {
        type: Array,
        required: true,
    },
    nested: {
        type: Boolean,
        default: false,
    },
});

const currentLocale = usePage().props?.locale ?? 'en';

function getText(step) {
    return step.text?.translations?.[currentLocale] ?? step.text?.translations?.en ?? '';
}
</script>
